import React from 'react';
import { brand } from '../theme/brand';

/**
 * Renders the "Tech Supply Chain" wordmark used in the app chrome (header and
 * auth cards). Rendered as styled text rather than an image so there is no
 * logo asset to maintain and no broken-image state to handle. `height` scales
 * the wordmark so existing call sites (which pass a pixel height) keep working.
 */
export default function BrandMark({ height = 36 }: { height?: number }) {
    return (
        <span
            style={{
                fontWeight: 800,
                fontSize: height * 0.5,
                letterSpacing: 0.5,
                lineHeight: 1,
                color: brand.navy,
                whiteSpace: 'nowrap',
            }}
        >
            Tech Supply Chain
        </span>
    );
}

BrandMark.defaultProps = {
    height: 36,
};
